import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-rich_qianjin",
  "use": "icon-rich_qianjin-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-rich_qianjin\">\r\n    <path d=\"M11 14.5C11.2761 14.5 11.5 14.7239 11.5 15C11.5 15.2761 11.2761 15.5 11 15.5V15V14.5ZM18 5L13 7.88675V2.11325L18 5ZM7 15V14.5H11V15V15.5H7V15ZM13.5 5V5.5H7V5V4.5H13.5V5ZM2 10H2.5C2.5 12.4853 4.51472 14.5 7 14.5V15V15.5C3.96243 15.5 1.5 13.0376 1.5 10H2ZM2 10H1.5C1.5 6.96243 3.96243 4.5 7 4.5V5V5.5C4.51472 5.5 2.5 7.51472 2.5 10H2Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol